import { useRef, useEffect } from "react";
import grapesjs from "grapesjs";
import grapesjsMJML from "grapesjs-mjml";

import { mergeTagCategories } from "../utils/mergeTags";

import dummyTemplate from "../utils/templatesCollection/dummytemplate";
import panelConfig from "./editor/config/panels";
import "grapesjs/dist/css/grapes.min.css";
import "./Editor.css";
import { isEmpty } from "lodash";
import wpmNotificationsCustomStoragePlugin from "./editor/plugins/storage";
import "./editor/plugins/rte";
import setStyleManagerConfig from "./editor/config/styleManager";

const Editor = (props) => {
  const initialEditorRender = useRef(true);
  // intialize storage plugin
  wpmNotificationsCustomStoragePlugin(props);

  // Initialze Grapes Js
  useEffect(() => {
    window.wpmVisualEditor = grapesjs.init({
      container: "#email-editor",
      fromElement: 1,
      avoidInlineStyle: false,
      // panels: { defaults: [] },
      plugins: [
        grapesjsMJML,
        "wpmNotificationsCustomStorage",
        "customRteOptions",
      ],
      pluginsOpts: {},
      height: "900px",
      // blockManager: {
      //     appendTo: '#email-editor-blocks',
      // },

      storageManager: {
        id: "", // Prefix identifier that will be used on parameters
        type: "metaboxStorage",
        autosave: true, // Store data automatically
        autoload: true,
      },
      assetManager: {
        // disable file upload functionality.. uploader hidden with css
        upload: false,
      },
      colorPicker: {
        appendTo: "parent",
        offset: { top: 26, left: -166 },
      },
      panels: panelConfig,
    });

    const editor = window.wpmVisualEditor;

    // set style manager config
    setStyleManagerConfig(editor);

    // Remove some default MJML blocks
    var blockstoRemove = ["mj-raw", "mj-navbar-link", "mj-navbar", "mj-hero"];

    blockstoRemove.forEach(function (blockName) {
      editor.BlockManager.remove(blockName);
    });

    //Open block manager on first load
    editor.on("load", function () {
      editor.Panels.getButton("views", "open-blocks").set("active", true);

      const result = [];
      const savedConfig = JSON.parse(window.wpmNotifications);
      const savedEditorConfig = !!savedConfig.editor ? savedConfig.editor : [];
      savedEditorConfig.forEach((savedData) => {
        for (var savedKey in savedData) {
          result[savedKey] = savedData[savedKey];
        }
      });

      props.updateEditorData(result);
    });

    // Remove unnecessay buttons
    ["sw-visibility", "mjml-import", "undo", "redo", "export-template"].forEach(
      (buttonName) => {
        editor.Panels.removeButton("options", buttonName);
      }
    );

    // Open  panel on any component selection
    editor.on("component:selected", function (cmp) {
      let settingsPanelsCmps = ["mj-image", "mj-button", "mj-social-element"];
      if (settingsPanelsCmps.indexOf(cmp.attributes.tagName) !== -1) {
        editor.Panels.getButton("views", "open-tm").set("active", true);
      } else {
        editor.Panels.getButton("views", "open-sm").set("active", true);
      }

      // open typography sector
      const typographySector = editor.StyleManager.getSector("typography");
      if (!!typographySector) {
        typographySector.setOpen(true);
      }
    });
  }, []);

  window.jQuery(".merge-tags-select").select2({
    // placeholder: "All",
  });

  // Manage merge tags according to Triggers
  useEffect(() => {
    const actionButtons = document.getElementsByClassName("gjs-rte-action");

    // using settimeout because actionButtons take time to get populated
    setTimeout(() => {
      for (let i = 0; i < actionButtons.length; i++) {
        if (actionButtons[i].getAttribute("data-custom-button")) {
          let mergeGroups = actionButtons[i].getElementsByTagName("optgroup");
          for (let j = 0; j < mergeGroups.length; j++) {
            mergeGroups[j].removeAttribute("disabled");
            let mergeGroupValue = mergeGroups[j].classList.value;

            mergeTagCategories.forEach((category) => {
              if (category.id === mergeGroupValue) {
                if (category.includedTriggers.indexOf(props.trigger) === -1) {
                  mergeGroups[j].setAttribute("disabled", "disabled");
                }
              }
            });
          }

          // 			const categoryId = actionButtons[i].getAttribute( 'title');

          // 			mergeTagCategories.forEach( category => {

          // 				if( category.id === categoryId ) {
          // 					if( category.includedTriggers.indexOf( props.trigger ) !== -1 ) {
          // 						actionButtons[i].style.display = 'inline-block';
          // 					}
          // 					else{
          // 						actionButtons[i].style.display = 'none';
          // 					}
          // 				}
          // 			});
        }
      }
    }, 500);
  }, [props.trigger]);

  // Manage Editor on change of template
  useEffect(() => {
    const editor = window.wpmVisualEditor;
    const savedSettings = JSON.parse(window.wpmNotifications);

    // This prevents it to run on the very first render of editor =
    // because on the very first render template we load the tempalate from database
    // if this works then it will rewrite the template with default config
    // the second condition makes sure if the settings in data base is empty then
    // load the tempalate
    if (initialEditorRender.current && !isEmpty(savedSettings.editor)) {
      initialEditorRender.current = false;
      return;
    }

    if (window.wp) {
      // is in wordpress interface
      fetch(window.ajaxurl, {
        method: "POST",
        body: new URLSearchParams({
          action: "wpm_notifications_load_template",
          id: props.template,
          nonce: window.wpm_notifications_ajax.nonce,
        }),
      })
        .then((response) => response.json())
        .then((components) => {
          editor.DomComponents.clear();
          editor.CssComposer.clear();
          editor.addComponents(components);

          // if it wasn't set to false ( because we are not getting template from database)
          initialEditorRender.current = false;
          // trigger store event so, state also get update template data ..
          editor.store();
        });
    } else {
      // load a dummy template to work in react localhost
      editor.DomComponents.clear();
      editor.CssComposer.clear();
      editor.addComponents(dummyTemplate);
    }

    // // if it wasn't set to false ( because we are not getting template from database)
    // initialEditorRender.current = false;
    // // trigger store event so, state also get update template data ..
    // 	editor.store();
  }, [props.template]);

  return (
    <div>
      {/* <div id="email-editor-blocks" />	 */}
      <div id="email-editor" />
    </div>
  );
};

export default Editor;
